import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { UserService } from "src/app/core/services/user.service";
import { TrgtEditAction, trgtOperationOptions } from "src/app/models/common";

@Component({
  selector: "app-campaign-daypart-targeting",
  templateUrl: "./campaign-daypart-targeting.component.html",
  styleUrls: ["./campaign-daypart-targeting.component.scss"],
})
export class CampaignDaypartTargetingComponent implements OnInit {
  @Input() stepInput: any;

  daypart: Array<any> = [];

  hourArray = [
    12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
    11,
  ];

  week = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
  };

  daypart_timezone: string;
  originalTimeZones: Array<any>;
  timeZoneOptions: Array<any>;
  searchTerm: string;

  bulkEditTrgtAct: TrgtEditAction;
  trgtOperations: Array<any> = [];


  isMouseDown = false;
  dragSelectMode: 'select' | 'deselect' = 'select';
  draggedHourIndexes = new Set<string>();
  draggedDay: string | null = null;

  constructor(
    private commonService: CommonService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.week = this.stepInput.week;
    if (this.stepInput.dsp == "vdsp") {
      this.daypart_timezone = this.stepInput.timeZone
        ? this.stepInput.timeZone
        : this.stepInput.clientTimeZone;
      this.getDayPartTimeZone();
    } else if (this.stepInput.dsp == "bdsp" && this.stepInput.isBulkEdit) {
      this.trgtOperations = trgtOperationOptions;
      this.bulkEditTrgtAct = this.stepInput.bulkEditTrgtAct;
    }
    document.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseDown(day: string, hour: number) {
    this.isMouseDown = true;
    this.draggedDay = day;
    const isAlreadySelected = this.week[day].includes(hour);
    this.dragSelectMode = isAlreadySelected ? 'deselect' : 'select';
    this.updateSlot(day, hour);
  }
  
  onMouseEnter(day: string, hour: number) {
    if (this.isMouseDown) {
      this.updateSlot(day, hour);
    }
  }
  
  onMouseUp() {
    this.isMouseDown = false;
    this.draggedDay = null;
    this.draggedHourIndexes.clear();
    this.proceed();
  }
  
  updateSlot(day: string, hour: number) {
    const key = `${day}-${hour}`;
    if (this.draggedHourIndexes.has(key)) return;
  
    const dayArray = this.week[day];
    const index = dayArray.indexOf(hour);
  
    if (this.dragSelectMode === 'select' && index === -1) {
      dayArray.push(hour);
    } else if (this.dragSelectMode === 'deselect' && index !== -1) {
      dayArray.splice(index, 1);
    }

    this.draggedHourIndexes.add(key);
  }
  

  getDayPartTimeZone() {
    this.userService.getDayPartTimeZones().subscribe((res) => {
      this.originalTimeZones = this.timeZoneOptions = res.timezones;
    });
  }

  searchTimeZone(value) {
    this.searchTerm = value;
    this.timeZoneOptions = this.originalTimeZones.filter((ele) =>
      ele.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  triggerEvent(event: boolean) {
    if (!event && this.searchTerm) {
      this.searchTimeZone("");
    }
  }

  selectTimeSlot(day, hour) {
    let exist_index = this.week[day].indexOf(hour);
    if (exist_index >= 0) {
      this.week[day].splice(exist_index, 1);
    } else {
      this.week[day].push(hour);
    }
    this.proceed();
  }

  clearDayPart() {
    let days = Object.keys(this.week);
    days.forEach((day) => {
      this.week[day].length = 0;
    });
    this.proceed();
  }

  checkDigit(val) {
    if (val <= 9 || val == 13) {
      return true;
    } else {
      return false;
    }
  }

  selectDay(day) {
    let all_hours = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23,
    ];
    if (this.week[day].length == all_hours.length) {
      this.week[day] = [];
    } else {
      this.week[day] = all_hours;
    }
    this.proceed();
  }

  selectTimeForEntireWeek(hour) {
    let days = Object.keys(this.week);
    let already_selected: boolean = true;
    for (let i = 0; i < days.length; i++) {
      if (this.week[days[i]].indexOf(hour) < 0) {
        already_selected = false;
        break;
      }
    }
    days.forEach((day) => {
      let hour_index = this.week[day].indexOf(hour);
      if (already_selected) {
        this.week[day].splice(hour_index, 1);
      } else if (hour_index < 0) {
        this.week[day].push(hour);
      }
    });
    this.proceed();
  }

  mapDayPart() {
    let days = Object.keys(this.week);
    let targetingArray = [];
    if (this.stepInput.dsp == "adsp") {
      days.forEach((day) => {
        let tempArray = [];
        let array = [];
        if (this.week[day].length > 0) {
          tempArray["day_of_week"] = day;
          tempArray["hour_slots"] = this.week[day];
          array.push(tempArray);
          tempArray = [];
        }
        array.forEach((item) => {
          let Obj = {};
          Obj["day_of_week"] = day;
          Obj["hour_slots"] = item["hour_slots"];
          targetingArray.push(Obj);
        });
      });
    } else {
      days.forEach((day) => {
        this.week[day];
        let array = [];
        let sortedArrHour = this.week[day].sort((a, b) => a - b);
        let tempArray = [];
        for (let i = 0; i < sortedArrHour.length; i++) {
          if (sortedArrHour[i + 1] - sortedArrHour[i] === 1) {
            tempArray.push(sortedArrHour[i]);
          } else {
            tempArray.push(sortedArrHour[i]);
            array.push(tempArray);
            tempArray = [];
          }
        }
        array.forEach((item) => {
          let Obj = {};
          Obj["day"] = day;
          Obj["start_hour"] = item[0];
          if (this.stepInput.dsp == "bdsp") {
            Obj["end_hour"] = item[item.length - 1] + 1;
          } else {
            Obj["end_hour"] = item[item.length - 1];
          }
          targetingArray.push(Obj);
        });
      });
    }
    this.daypart = targetingArray;
  }

  proceed() {
    this.mapDayPart();
    this.commonService.setDaypart({
      dayPart: this.daypart,
      dayPartTimeZone: this.daypart_timezone,
    });
  }

  ngOnDestroy() {
    document.removeEventListener('mouseup', this.onMouseUp.bind(this));
  }  
}
